export const environment = {
  production: true,
  serverUrl: 'https://realestate.dev.adsaver-new.com',
  wpFileUrl: 'https://realestate-sftp-data-eu-central-1-397114334021.s3.eu-central-1.amazonaws.com/dev/wp-content/',
  mapbox: {
    accessToken: 'pk.eyJ1Ijoib2xla3NhbmRyLXN2aXQtc29mdCIsImEiOiJja240bjhmYmgwa2V0MnBvMDR6bjVkaXh1In0.ioDcubFmhmrwFRQH2jTXWA'
  },
  isShowImport: true
};
